import request from '../utils/request';

export default {

  createCfdd(params) {
    // return request.post('/zfmk/jfdd/scjfdd', params);
  },

  createCzdd(params) {
    // return request.post('/zfmk/jfdd/scczdd', params);
  },

  createUnbindingCzdd(params) {
    // return request.post('/open/jfdd/scczdd', params);
  },

  ccbQRCode(params) {
    // return request.get('/ccbpay/QRCode', params);
  },

  ccbUnbindingQRCode(params) {
    // return request.get('/open/QRCode', params);
  },
  //
  // // 惠市宝    聚合支付 --单一下单
  // gatherByPlaceorder(params) {
  //   return request.post('https://wx.gsjhfz.com:8893/3rdapi/open/ccbpay/hsb/gatherByPlaceorder', params);
  //   // return request.post_openapi('/open/ccbpay/hsb/gatherByPlaceorder', params);
  // },

  // 惠市宝    聚合支付 --单一下单
  gatherByPlaceorder(params) {
    return request.post('/open/hsb/gatherByPlaceorder', params);
  },
};



// WEBPACK FOOTER //
// ./src/api/zfmk.api.js